<template>
    <div>
        <vue-headful title="Equipment Date Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link to="/equipment">
                        <i class="fa fa-truck"></i> Equipment
                    </router-link>
                </li>
                 <li class="breadcrumb-item font-weight-light">
                    <router-link to="/equipment#types">
                        Types
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/equipment/types/edit/${equipment_type_id}#alerts`">
                        {{ alert.equipment_type.equipment_type_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    <template v-if="id"><i class="fa fa-edit"></i> Edit</template>
                    <template v-else><i class="fa fa-plus"></i> Create</template> Date Alert
                </li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-4 col-12">
                    <div class="card">
                        <div class="card-header">Date Alert Details</div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div :class="{'col-md-4': true, 'text-danger': errors.alert_name ,'text-muted': !errors.alert_name}">Alert Name:</div>
                                <div class="col-md-8">
                                    <input type="text" name="alert_name" v-model="alert.alert_name" :class="{'form-control': true, 'is-invalid': errors.alert_name}" placeholder="Enter Alert Name" />

                                    <span v-if="errors.alert_name" class="text-danger">
                                        <span v-for="error in errors.alert_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Active:</div>
                                <div class="col-md-8">
                                    <b-form-checkbox v-model="alert.is_active" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Description:</div>
                                <div class="col-md-8">
                                    <textarea class="form-control" placeholder="Enter Alert Description (Optional)" v-model="alert.description" rows="4">{{ alert.description }}</textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            Conditions
                            <button class="btn btn-sm btn-info" type="button" @click="conditions.push({equip_field_id: null, field_type: 'Custom Field', field_value: null, cond_value_formatted: null, cond_sign: 'Away'})"><i class="fa fa-plus"></i> Add</button>
                        </div>
                        <div class="card-body form-inline">
                            <ol>
                                <!-- This will need to be tweaked if we add another field type option (i.e. usage) -->
                                <li v-for="(cond, i) in conditions" class="mb-2">
                                    <a href="javascript:void" class="text-danger btn-link" @click="deleteCondition(i);"><i class="fa fa-trash"></i></a>
                                    <strong>WHEN </strong>

                                    <!-- There's no actual options here yet, just Custom Field -->
                                    <b-form-select class="form-control d-none" v-model="cond.field_type" :options="fieldOptions" />

                                    <b-form-select class="form-control" v-model="cond.field_value" :options="logicOptions(cond.field_type)" />

                                    <strong> IS </strong>

                                    <input type="text" class="form-control" v-model="cond.cond_value_formatted" placeholder="Enter Number of Days" />

                                    <strong> DAYS </strong>

                                    <b-form-select class="form-control" v-model="cond.cond_sign" :options="['Away', 'Past']" />

                                    <span v-if="errors['conditions['+i+']']" class="text-danger">
                                        <br>
                                        <span v-for="(error, key) in errors['conditions['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                                    </span>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header">
                            Recipients
                            <button class="btn btn-sm btn-info" type="button" @click="recipients.push({target_type: null, target_value: null})"><i class="fa fa-plus"></i> Add</button>
                        </div>
                        <div class="card-body form-inline">
                            <strong>Send Email To:</strong>
                            <ol>
                                <li v-for="(recip, i) in recipients" class="mb-2">
                                    <a href="javascript:void" class="text-danger btn-link" @click="deleteRecipient(i);"><i class="fa fa-trash"></i></a>

                                    <b-form-select class="form-control" v-model="recip.target_type" :options="recipientOptions" />

                                    <span>=</span>

                                    <span v-if="recip.target_type == 'Employee'" class="d-lg-inline-block" style="width: 400px;">
                                        <employee-select
                                            :selectedValues="recip.target_label ? {EmployeeId: recip.target_label.EmployeeId, FirstName: recip.target_label.FirstName, LastName: recip.target_label.LastName, EmployeeNumber: recip.target_label.EmployeeNumber} : null"
                                            @vselected="function(employee){ recip.target_value = employee.EmployeeId; }"
                                            :hasError="errors['recipients['+i+']'] ? true : false" />
                                    </span>

                                    <template v-if="recip.target_type == 'Employee Title'">
                                        <!-- <input type="text" v-model="recip.target_value" placeholder="Enter an Employee Title/Position" class="form-control" /> -->
                                        <b-form-select v-model="recip.target_value" :options="titleOptions" :class="{'is-invalid': errors['recipients['+i+']']}" />
                                    </template>

                                    <template v-if="recip.target_type == 'Email'">
                                        <input type="text" v-model="recip.target_value" placeholder="Enter an Email Address" class="form-control" />
                                    </template>

                                    <template v-if="recip.target_type == 'Role'">
                                        <b-form-select class="form-control" v-model="recip.target_value" :options="roleOptions" />
                                    </template>

                                    <span v-if="recip.target_type == 'User'" class="d-lg-inline-block" style="width: 400px;">
                                        <user-select
                                            :selectedValues="recip.target_label ? {UserId: recip.target_label.UserId, FirstName: recip.target_label.FirstName, LastName: recip.target_label.LastName} : null"
                                            @vuselected="function(user){ recip.target_value = user.UserId; }"
                                            :hasError="errors['recipients['+i+']'] ? true : false" />
                                    </span>

                                    <span v-if="errors['recipients['+i+']']" class="text-danger">
                                        <br>
                                        <span v-for="(error, key) in errors['recipients['+i+']']"><template v-if="key > 0">, </template>{{ error }}</span>
                                    </span>
                                </li>
                            </ol>

                            <div v-if="errors.recipients" class="alert alert-danger">
                                <span v-for="(error, key) in errors.recipients"><template v-if="key > 0">, </template>{{ error }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" @click="saveAlert()" :disabled="saving">
                <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                <template v-else>Save Equipment Email Alert</template>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                equipment_type_id: this.$route.query.equipment_type_id,
                equipment_types: [],
                loading: true,
                saving: false,
                errors: {},
                alert: {},
                field_types: [],
                conditions: [],
                recipients: [],
                recipientTypes: [],
                titles: [],
            }
        },

        computed: {

            fieldOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Field Type --'}
                ];

                //Field Arrya
                var fieldArray = Object.values(this.field_types);

                //Loop
                for(var i = 0; i < fieldArray.length; i++)
                {
                    //Push
                    options.push({value: fieldArray[i], text: fieldArray[i]});
                }

                //Send it
                return options;
            },

            recipientOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Target Type --'}
                ];

                //Loop
                for(var i = 0; i < this.recipientTypes.length; i++)
                {
                    //Push
                    options.push({value: this.recipientTypes[i], text: this.recipientTypes[i]});
                }

                //Send it
                return options;
            },

            roleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Role --'}
                ];

                //Loop
                for(var i = 0; i < this.roles.length; i++)
                {
                    //Push
                    options.push({value: this.roles[i].id, text: this.roles[i].name});
                }

                //Send it
                return options;
            },

            titleOptions(){
                //Build it
                var options = [
                    {value: null, text: '-- Select a Title --'}
                ];

                //Loop
                for(var i = 0; i < this.titles.length; i++)
                {
                    //Push
                    options.push({value: this.titles[i], text: this.titles[i]});
                }

                //Send it
                return options;
            },

            customFieldOptions() {
                return JSON.parse(this.equipment_types[this.alert.equipment_type_id]);
            },
        },

        methods: {
            logicOptions(field_type){
                if (field_type == 'Custom Field')
                {
                    //Build it
                    var options = [
                        {value: null, text: '-- Select a Custom Field --'}
                    ];

                    //Loop
                    if (Array.isArray(this.customFieldOptions))
                    {
                        for(var i = 0; i < this.customFieldOptions.length; i++)
                        {
                            //Push
                            options.push({value: this.customFieldOptions[i].id, text: this.customFieldOptions[i].label});
                        }
                    }

                    //Send it
                    return options;
                }

                return [];
            },

            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('admin/equipment-alerts/edit' + (this.id ? '/' + this.id : ''), this.$route.query)
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;
                        this.field_types = res.data.field_types;
                        this.conditions = this.alert.conditions;
                        this.recipients = this.alert.recipients;
                        this.recipientTypes = res.data.recipientTypes;
                        this.roles = res.data.roles;
                        this.titles = res.data.titles;
                        this.equipment_types = res.data.equipment_types;
                        // If we have a type already, set it on the page, otherwise set the model's value to the page's
                        if (this.alert.equipment_type_id)
                        {
                            this.equipment_type_id = this.alert.equipment_type_id;
                        }
                        else
                        {
                            this.alert.equipment_type_id = this.equipment_type_id;
                        }
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteCondition(key){
                //Splice
                this.conditions.splice(key, 1);
            },

            deleteRecipient(key){
                //Splice
                this.recipients.splice(key, 1);
            },

            saveAlert(){
                //Saving Flag
                this.saving = true;
                this.errors = {};

                //Set the values
                this.alert.conditions = this.conditions;
                this.alert.recipients = this.recipients;

                //Send it
                this.$http.post('admin/equipment-alerts/edit', this.alert)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Equipment Email Alert Saved');

                        //Send to the View
                        this.$router.push('/admin/equipment-alerts/view/' + res.data.id);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Save Alert');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            }
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
